import { type AccountAuthUser } from '../async/account'
import { ActionToolAccountWithId } from '../types/account-types'
import { initializeAccount } from './account'

export const getEmailFrom = (user?: AccountAuthUser) => {
  return user?.email
}
export const getUidFrom = (user?: AccountAuthUser) => {
  return user?.uid
}

export const handleAuthUser = async (
  authUser?: AccountAuthUser,
  onLoadedAccount?: (user: ActionToolAccountWithId) => void
) => {
  const email = getEmailFrom(authUser)
  const uid = getUidFrom(authUser)
  if (email && uid) {
    return await initializeAccount(uid, email, onLoadedAccount)
  }
}
